import { useSyncExternalStore } from "react";

export interface AccessGateState {
  loading: boolean;
  gateOpen: boolean;
}

let currentState: AccessGateState = {
  loading: true,
  gateOpen: false,
};

const listeners = new Set<() => void>();

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export function setAccessGateState(next: Partial<AccessGateState>) {
  const merged: AccessGateState = {
    ...currentState,
    ...next,
  };

  if (
    merged.loading === currentState.loading &&
    merged.gateOpen === currentState.gateOpen
  ) {
    return;
  }

  currentState = merged;
  emitChange();
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot(): AccessGateState {
  return currentState;
}

const serverSnapshot: AccessGateState = {
  loading: true,
  gateOpen: false,
};

function getServerSnapshot(): AccessGateState {
  return serverSnapshot;
}

export function useAccessGate(): AccessGateState & { accessGranted: boolean } {
  const state = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const accessGranted = !state.loading && !state.gateOpen;

  return {
    loading: state.loading,
    gateOpen: state.gateOpen,
    accessGranted,
  };
}
